import React, { useCallback } from 'react';
import i18n from '../../Shared/Translation/i18n';
import InputCont from '../../Shared/Form/InputCont';
import useDetail from '../../Shared/useDetail';
import { ApiUrl } from '../../project/Defines.js';
import { EVENT_NAME } from '../../project/utilities';


export default function Applications(props) {
    const reloadEvent = EVENT_NAME.SALES_NETWORK_APPLICATION_LIST_UPDATE;

    const dataLoadUrl =  props.isThercodim ? ApiUrl.ThercodimSalesNetworkApplicationsLoad : ApiUrl.SalesNetworkApplicationsLoad;

    const isThercodimObj = props.isThercodim? {isThercodim:props.isThercodim }: {};

    const { dataItem, setDataItem, updateData, /*closePopup, detailRef, onChangeData,*/ validation } = useDetail({
        data: {},
        onLoadData: (response, _setDataItem) => {
            const data = [];
            for (const element of response.data) {

                if (!data.filter((item) => item.applicationId === element.applicationId).length) {
                    data.push({
                        applicationId: element.applicationId,
                        appLabel: element.appLabel,
                        isAppSelected: element.isAppSelected,
                        subApplications: response.data.filter((j) => j.applicationId === element.applicationId)
                    });
                }
            }
            _setDataItem(data);
            return true;
        },
        updateUrl: ApiUrl.SalesNetworkApplicationsUpdate,
        dataLoadUrl: dataLoadUrl,
        reloadEvent
    });

    const updateSuccessCallback = useCallback((response) => {
        return true;
    }, [/*setDataItem, closePopup, detailRef, reloadEvent*/]);

    const dataChange = (e) => {
        const newData = [...dataItem];

        for (const element of newData) {
            if (element.appLabel === e.target.name) {
                element.isAppSelected = e.target.checked;
                if (!e.target.checked) {
                    for (let subApp of element.subApplications) {
                        subApp.isSubAppSelected = false;
                    }
                } else {
                    for (let subApp of element.subApplications) {
                        subApp.isSubAppSelected = true;
                    }
                }
                break;
            }
        }
        updateData(updateSuccessCallback, null, { overrideData: { applicationId: +e.target.value, isChecked: e.target.checked, changeAll: true, ...isThercodimObj}});

        setDataItem(newData);
    };

    const subDataChange = (e, parentID) => {// NOSONAR
        const newData = [...dataItem];

        for (const element of newData) {
            if (element.applicationId === parentID) {
                if (!element.isAppSelected && e.target.checked) {
                    element.isAppSelected = true;
                    updateData(updateSuccessCallback, null, { overrideData: { applicationId: element.applicationId, isChecked: e.target.checked, changeAll: false, ...isThercodimObj} });
                }

                if (!e.target.checked && element.subApplications.filter(subItem => subItem.isSubAppSelected).length === 1) {
                    element.isAppSelected = false;
                    updateData(updateSuccessCallback, null, { overrideData: { applicationId: element.applicationId, isChecked: e.target.checked, changeAll: false, ...isThercodimObj } });
                    for (let subApp of element.subApplications) {
                        if (subApp.subAppLabel === e.target.name) {
                            subApp.isSubAppSelected = e.target.checked;
                        }
                    }
                    setDataItem(newData);
                    return;
                }

                for (let subApp of element.subApplications) {
                    if (subApp.subAppLabel === e.target.name) {
                        subApp.isSubAppSelected = e.target.checked;
                    }
                }
                break;
            }
        }
    
        updateData(updateSuccessCallback, null, { overrideData: { applicationId: +e.target.value, isSubApplication: true, isChecked: e.target.checked, ...isThercodimObj } });

        setDataItem(newData);
    };

    return <div className="section_group">
        <div className="sections extra">
            <div className="form_fields"><div className="section_title"><text>{i18n("text.applications")}</text></div><div className="form_separator"></div></div>
            {
                dataItem && dataItem.map(item => (<div className="form_fields" key={item.appLabel}>
                    <cont>
                        <div style={{'minWidth': '300px'}}><InputCont label={item.appLabel} inputProps={{ validation, name: item.appLabel, type: 'checkbox', value: item.applicationId, onChange: dataChange, checked: item.isAppSelected }} /></div>
                        {item.subApplications && item.subApplications.map(subItem => (<InputCont key={subItem.subAppLabel} label={subItem.subAppLabel} inputProps={{ validation, name: subItem.subAppLabel, type: 'checkbox', value: subItem.subApplicationId, onChange: (e) => { subDataChange(e, item.applicationId) }, checked: subItem.isSubAppSelected }} />))}
                    </cont>
                </div>))
            }
        </div>
    </div>
}